import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Schema } from './create/components/license-form.schema';
import { keys } from './queries';
import { keys as personKeys } from '../person/queries';
import { SSF } from '~/apis/api';

export function useCreateLicenseMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (variables: Parameters<typeof SSF.api.licensesCreate>[0]) => SSF.api.licensesCreate(variables),
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: keys.lists(),
      });
      client.invalidateQueries({
        queryKey: personKeys.all,
      });
    },
  });
}

export function useUpdateLicenseMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, person, ...payload }: { id: number; person: number } & Schema) => {
      return await SSF.api.licensesUpdate(id, {
        ...payload,
        club: payload.club[1],
        person,
      });
    },
    onSuccess: () => client.invalidateQueries({ queryKey: keys.all }),
  });
}

export function useDeleteLicenseMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (variables: Parameters<typeof SSF.api.licensesDestroy>[0]) => SSF.api.licensesDestroy(variables),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: keys.lists() });
      client.invalidateQueries({ queryKey: personKeys.all });
    },
  });
}
